import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import type { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { RetirementIconTile } from "web_myplann/Inspiration/Retirement/Components/RetirementIconTile";
import {
	RETIREMENT_DRAWDOWN_OPTIONS,
	RETIREMENT_DRAWDOWN_YEARS,
} from "web_myplann/Inspiration/Retirement/constants";

type Props = {
	selectedMode: RentDrawdownMode;
	onSelect: (mode: RentDrawdownMode) => void;
};

export const RetirementDrawdownList: FC<Props> = ({
	selectedMode,
	onSelect,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack direction="row" gap={theme.spacingTokens.sm}>
			{RETIREMENT_DRAWDOWN_OPTIONS.map((option) => (
				<RetirementIconTile
					key={option.mode}
					icon={option.icon}
					label={t(option.copy.label, { years: RETIREMENT_DRAWDOWN_YEARS })}
					description={t(option.copy.description)}
					uppercase
					selected={selectedMode === option.mode}
					onClick={() => onSelect(option.mode)}
				/>
			))}
		</Stack>
	);
};
